/** @jsxImportSource @emotion/react */
'use client'

import { css } from '@emotion/react'
import type { ReactNode } from 'react'

const base = css`
  max-width: 1280px;
  margin-inline: auto;
`

interface ContainerProps {
  children: ReactNode
  className?: string
}

export default function Container({ children, className }: ContainerProps) {
  // When a parent (e.g. Hero) renders <Container css={...}>, emotion's jsx
  // runtime serialises that css into `className`, so we forward it here. Emotion
  // composes it after `base`, letting caller styles override the defaults.
  return (
    <div css={base} className={className}>
      {children}
    </div>
  )
}
